import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex)
export default new vuex.Store({
  // 使用响应式数据请初始化字段
  state: {
    userInfo: {
      headimgurl: '',
      openid: '',
      sex: 0
    }
  },
  mutations: {
    setUserInfo (state, userObj) {
      state.userInfo = userObj
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js